import Vue from 'vue';

Vue.component('travel-distance', {
    data() {
        return {
            tabIndex: 0,
        };
    },

    mounted() {},

    methods: {
        switchTab(index) {
            if (index != this.tabIndex) {
                this.tabIndex = index;
            }
        },

        changeTabContainerClass(index) {
            return index === this.tabIndex
                ? 'travel-block__option--active'
                : '';
        },
    },
});
